export default "__VITE_ASSET__xNFXgA22__"